if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
     console.log(this.submitButton );
      let r = (Math.random() + 1).toString(36).substring(2);
      if($('.mainP_random').length > 0){
      $('.mainP_random, .bundle_random').val(r);
      }
       if($('.additional_product').length  >0){
       var v= $('input[name="id"]',this).val();
        if($('.additional_product').attr('data-variant') == v && $('.additional_product').attr('data-add-product') !=''){
          
        }
      }
     
 
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
       var _this = this;
      this.handleErrorMessage();
     if(!$(this).hasClass('buynow')){
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
     }else{
      $(this).find('.buy-it-now-cstm1').attr('aria-disabled', true);
      $(this).find('.buy-it-now-cstm1').addClass('loading');
      $(this).find('.buy-it-now-cstm1 .loading-overlay__spinner').removeClass('hidden');
      }
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
    
      if (this.cart && ! $(this).hasClass('buynow')) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      var error_check = 0;
       if($('.p_type').val() =='Combo' && this.submitButton.classList.contains('popup-product-submit')== false){
            var combo_product_data=[];
             var checkId =[];
            
          /** check the two same variant add in the bundle ***/
           $('.bunddle_inner_outer  form').each(function(){
             checkId.push($.trim($('input[name="id"]',this).val()));
           });
             var repeatedVid = checkId.sort(); 
            var  CheckDuplicateId = [];
            for (var i = 0; i < repeatedVid.length -1 ; i++) {
            if (repeatedVid[i + 1] == repeatedVid[i]) {
          CheckDuplicateId.push(repeatedVid[i]);
            }
            }
          
        const counts = {};
        repeatedVid.forEach(function (x) { 
          if(jQuery.inArray(x, CheckDuplicateId) != -1){  
          counts[x] = (counts[x] || 0) + 1; 
          }
          });
       
            /** Get unique ID**/
            var uniqueVID = repeatedVid.filter(function(itm, i, a) {
            return i == repeatedVid.indexOf(itm);
            });
         /** Get unique ID  end here**/
   
         $(uniqueVID).each(function(index,val){
            var items = {};
            var _double_qty ='';
              var BundleVid =val;
              /** check the two same variant add in the bundle ***/
              console.log(checkId);
              console.log(jQuery.inArray(BundleVid, checkId));
              if(jQuery.inArray(BundleVid, CheckDuplicateId) != -1){
                _double_qty = "true";
                var bundleCount = parseInt(counts[BundleVid]);
                
              console.log(BundleVid);
               items['id'] = $.trim(val);
               items['quantity'] = $('.quantity__input').val() * bundleCount;
                var combo_name = $('.combo_name[data-vid="'+BundleVid+'"]').val();
               var discount_name = $('.discount_name[data-vid="'+BundleVid+'"]').val();
                var bundle_random = $('.bundle_random[data-vid="'+BundleVid+'"]').val();
              /** Check collection discount properties value **/
             // var propertyData={};
               var propertyData={};
             //  if($('.col-discount-main[data-vid="'+BundleVid+'"] .collectionDis_field').length > 0){
                
             //    $('.col-discount-main[data-vid="'+BundleVid+'"] .collectionDis_field').each(function(){
             //      var propertyName= $(this).attr('data-name');
             //      var propertyval= $(this).val();
             //      if(propertyval == ''){
             //        propertyval= ' ';
             //      }
             //      propertyData[propertyName]= propertyval;
             // });
                 
             //  }
            
             
              //console.log(propertyData.concat(p));
             
              if(discount_name == 0){
                items['properties'] = {"combo name":combo_name,"_bundle_discount":discount_name,"_random no":bundle_random,_double_qty};
                // if($('.collectionDis_field',this).length > 0){
                // items['properties']._collection_discount = propertyData._collection_discount;
                // items['properties']._collection_discount_value = propertyData._collection_discount_value;
                // items['properties']._collection_exluded_variant = propertyData._collection_exluded_variant;
                // items['properties']._collection_discount_message = propertyData._collection_discount_message;
                // }
              }else{
               items['properties']= {"_sub_combo_product":true,"combo name":combo_name,"_bundle_discount":discount_name,"_random no":bundle_random,_double_qty};
              //items['properties'].push(propertyData);
              }
               combo_product_data.push(items);
              }
            });
          /** check the two same variant add in the bundle END HERE***/
            $('.bunddle_inner_outer  form').each(function(){
               var items = {};
               var _double_qty ='';
              var BundleVid = $.trim($('input[name="id"]',this).val());
              /** check the two same variant add in the bundle ***/
              console.log(checkId);
              console.log(jQuery.inArray(BundleVid, checkId));
              if(jQuery.inArray(BundleVid, CheckDuplicateId) == -1){
                _double_qty = "true";
                items['id'] = $.trim($('input[name="id"]',this).val());
               items['quantity'] = $('.quantity__input').val();
                var combo_name = $('.combo_name',this).val();
               var discount_name = $('.discount_name',this).val();
                var bundle_random = $('.bundle_random',this).val();
              /** Check collection discount properties value **/
             // var propertyData={};
               var propertyData={};
              if($('.collectionDis_field',this).length > 0){
                
                $('.collectionDis_field',this).each(function(){
                  var propertyName= $(this).attr('data-name');
                  var propertyval= $(this).val();
                  if(propertyval == ''){
                    propertyval= ' ';
                  }
                  propertyData[propertyName]= propertyval;
             });
                 
              }
            
             
              //console.log(propertyData.concat(p));
             
              if(discount_name == 0){
                items['properties'] = {"combo name":combo_name,"_bundle_discount":discount_name,"_random no":bundle_random,_double_qty};
                if($('.collectionDis_field',this).length > 0){
                items['properties']._collection_discount = propertyData._collection_discount;
                items['properties']._collection_discount_value = propertyData._collection_discount_value;
                items['properties']._collection_exluded_variant = propertyData._collection_exluded_variant;
                items['properties']._collection_discount_message = propertyData._collection_discount_message;
                }
              }else{
               items['properties']= {"_sub_combo_product":true,"combo name":combo_name,"_bundle_discount":discount_name,"_random no":bundle_random,_double_qty};
              //items['properties'].push(propertyData);
               
              
              }
              
                 combo_product_data.push(items);
              }
            });
    
            console.log(combo_product_data);
             $.ajax({
                method: "POST",
                dataType: 'json',
                url: "/cart/add.js",
                async: false,
                data:{items:combo_product_data},
                success: function(data) {
                    console.log(data);
                },
             error:function(response){
               console.log(response.responseJSON.description);
               $('.product-form__error-message-wrapper').removeAttr('hidden');
               $('.product-form__error-message').html(response.responseJSON.description);
               error_check = 1;
                 _this.submitButton.classList.remove('loading');
          if (_this.cart && _this.cart.classList.contains('is-empty')) _this.cart.classList.remove('is-empty');
          if (!_this.error) _this.submitButton.removeAttribute('aria-disabled');
          _this.querySelector('.loading-overlay__spinner').classList.add('hidden');
               return;
             }
           });
          }
      if(error_check == 0){
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          
 /** add additional product **/
          /*
            console.log(response.id);
              if($('.additional_product').length > 0 && response.id == $.trim($('.additional_product').attr('data-variant'))){
               var items = {};
              var combo_product_data=[];
               items['id'] = $('.additional_product').attr('data-add-product');
               items['quantity'] = 1;
              var discount=$('.additional_product').attr('data-discount');
              items['properties']= {"_Free_product":true,'_discount':discount};
              combo_product_data.push(items);
             $.ajax({
                method: "POST",
                dataType: 'json',
                url: "/cart/add.js",
                async: false,
                data:{items:combo_product_data},
                success: function(data) {
                },
             error:function(response){
               console.log(response.responseJSON.description);
              }
           });
          
          }*/
           /** add additional product END HERE**/ 
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
           
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
    var _this = this;
         this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      
          if($('.fitness-popup-outer').length > 0 ){
            $.ajax({
                method: "GET",
                url: "/?sections=planet-fitness-popup",
                async: false,
                success: function(data) {
  
             //  console.log(data['planet-fitness-popup']);
                var checkFitness=$('.fitness-popup-outer',data['planet-fitness-popup']).attr('data-check'); 
                var checkTotal=parseInt($('.fitness-popup-outer',data['planet-fitness-popup']).attr('data-cart-total'));
                 var checkOrderlimit=parseInt($('.fitness-popup-outer',data['planet-fitness-popup']).attr('data-order-limit'));  
                 
                 if(checkFitness == 'false' && checkOrderlimit < checkTotal) {
                 //  $('.fitness-popup-outer').css('display','flex');
                    $('#product-form-planet-fitness-popup input[name="id"]').val($('#product-form-planet-fitness-popup input[name="id"]').attr('data-value'));
                   $('.popup-product-submit').trigger('click');
                  
                 } 
                  setTimeout(function(){
                     if($(_this).hasClass('buynow')){
                    window.location.href = "/checkout";
                    } 
                    },1000);
                },
             error:function(response){}
            });

          }else{
               if($(_this).hasClass('buynow')){
                    window.location.href = "/checkout";
                    }
          }
        
          if(this.submitButton.classList.contains('popup-product-submit') == true){
          $('.fitness-popup-outer').hide();
          sessionStorage.setItem("fintessPopup", "true");
            
          }
          
          
          
      
        });
           
    }
    }
    
    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
